import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["Requested","Awaiting Confirmation","Confirmed","Preparing","Ready","Completed","Cancelled"];

export default function AdminLechon() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/lechon").then(({data}) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const update = async (id, status) => { await api.patch(`/lechon/${id}/status`, { status }); toast.success("Updated"); load(); };
  return (
    <div data-testid="admin-lechon">
      <h1 className="font-heading text-3xl text-[#FAF9F6] mb-5">Lechon Reservations</h1>
      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[#D4AF37]/80 text-xs uppercase border-b border-[#D4AF37]/15">
            <th className="p-3">Customer</th><th>Phone</th><th>Type</th><th>Qty</th><th>Pickup</th><th>Notes</th><th>Status</th>
          </tr></thead>
          <tbody>
            {items.map(r => (
              <tr key={r.id} className="border-b border-white/5">
                <td className="p-3 text-[#FAF9F6]">{r.customer_name}</td>
                <td className="text-[#FAF9F6]/70">{r.customer_phone}</td>
                <td className="font-accent text-[#D4AF37] text-xs">{r.lechon_type.toUpperCase()}</td>
                <td>{r.quantity}</td>
                <td className="text-xs">{r.pickup_date} {r.pickup_time}</td>
                <td className="text-xs text-[#FAF9F6]/60 max-w-[200px] truncate">{r.notes}</td>
                <td>
                  <select value={r.status} onChange={(e) => update(r.id, e.target.value)} className="bg-[#0B0E14] border border-[#D4AF37]/30 text-xs px-2 py-1 rounded text-[#FAF9F6]">
                    {STATUSES.map(s => <option key={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="7" className="p-6 text-center text-[#FAF9F6]/40">No reservations</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
